import { Checkbox } from "components/designV2/checkbox/checkbox";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  arrayToStringForBackend,
  stringNormalize,
} from "./companySystemSettings.logic";
import { SettingsCheckboxGrid } from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

const ALL_VALUE = "All";
const SICK_LEAVE_PAY_VALUE = "SickLeavePay";
const OPTION_VALUES = [SICK_LEAVE_PAY_VALUE];

const toSelectedSet = (value: string): Set<string> => {
  const entries = stringNormalize(value).split(", ");
  return new Set(entries.includes(ALL_VALUE) ? OPTION_VALUES : entries);
};

export const CompanyHourlySalaryConfigSetting: React.FC<{
  value: string;
  onChange: (value: string) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const selectedSet = toSelectedSet(value);
  const isSelected = (type: string) => selectedSet.has(type);

  const toggle =
    (type: string) =>
    (isChecked: boolean): void => {
      const nextSet = new Set(selectedSet);
      if (isChecked) nextSet.add(type);
      else nextSet.delete(type);

      onChange(arrayToStringForBackend(Array.from(nextSet)));
    };

  return (
    <SystemSettingRow
      title={t("System.CompanyHourlySalaryConfig")}
      description={t("System.CompanyHourlySalaryConfigInfo")}
      controlVerticalAlign="start"
    >
      <SettingsCheckboxGrid>
        <Checkbox
          label={t("System.CompanyHourlySalaryConfigSickLeavePay")}
          checked={isSelected(SICK_LEAVE_PAY_VALUE) ? "checked" : "unchecked"}
          onChange={toggle(SICK_LEAVE_PAY_VALUE)}
        />
      </SettingsCheckboxGrid>
    </SystemSettingRow>
  );
};
